// Shared Supabase client + CRUD from @packages/base. Initialised in app/providers.tsx.
export * from "@packages/base/utils/supabase"

import { buildSupabaseUrl } from "@packages/base/utils/supabase"

import { DOMAIN, ENVIRONMENT, PLATFORM } from "@/app/config"

export const SUPABASE_ANON_KEY = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY
export const SUPABASE_URL =
  process.env.NEXT_PUBLIC_SUPABASE_URL ??
  buildSupabaseUrl({ domain: DOMAIN, environment: ENVIRONMENT, platform: PLATFORM })
export const isSupabaseConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY)
